import getText from "./getText";

const checkRequiredDetails = (
  { storyQuestionId, selectedBody }) => storyQuestionId && getText(selectedBody).length > 0;

export default checkRequiredDetails;
